<template>
  <div class="app-container">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox">
        <div class="detailsTitle">
          <h4>消息通知</h4>
          <div @click="back"><i class="fa fa-reply"></i></div>
        </div>
      </div>
      <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%" :show-header="false"  :cell-style="tableStyle"  >
        <el-table-column  prop="messageTitle"  min-width="120" :formatter="emptyFn" label="" >
          <template slot-scope="scope">
            <div style="text-align: left">
              <i class="fa fa-envelope" style="font-weight: 700" v-if="scope.row.readStatus != 2"></i>
              <i class="fa fa-envelope-open"  style="color:	#A9A9A9" v-if="scope.row.readStatus == 2" ></i>
              <span  style="margin-left: 5px;color:	#A9A9A9" v-if="scope.row.readStatus == 2">{{ scope.row.messageTitle }}</span>
              <span  style="margin-left: 5px;font-weight: 700" v-if="scope.row.readStatus != 2">{{ scope.row.messageTitle }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="messageContent"  min-width="500" label="" align="left">
          <template slot-scope="scope">
            <div style="text-align: left">
              <span  style="margin-left: 5px;color:	#A9A9A9" v-if="scope.row.readStatus == 2">{{ scope.row.messageClassify == 2?scope.row.messageContent: scope.row.messageTitle }}</span>
              <span  style="margin-left: 5px;font-weight: 700" v-if="scope.row.readStatus != 2">{{ scope.row.messageClassify == 2?scope.row.messageContent: scope.row.messageTitle}}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="messageType"  min-width="100" :formatter="emptyFn" label="">
          <template scope="scope">{{[ "公告", "私信"][scope.row.messageType-1]}}</template>
        </el-table-column> -->
        <el-table-column prop="releaseTime"  min-width="180" :formatter="dateTimeFormat" label="" align="right"></el-table-column>
      </el-table>
    </div>
      <!--分页-->
      <div class="pags" style="text-align: left;">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-size="searchFrom.pageSize"
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { receiveMsgList, readMsg, receiveMsgNoReadSum } from '@/api/common.js'
export default {
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        userType: 1
      },
      total: 0,
      loading: false,
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 165) + 'px'
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 查选
    // searchFn () {
    //   if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
    //   this.getList(this.searchFrom)
    // },
    searchFn () {
      if (this.searchFrom.billNo) { this.searchFrom.billNos = this.searchFrom.billNo.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.billNos = ''
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      if (row.messageClassify == 2) {
        readMsg({ messageId: row.id, userType: 1 }).then(res => {
          receiveMsgNoReadSum({
            userType: 1
          }).then(res => {
            this.$emit('msgFn', res)
            this.$router.push({ name: 'qiYunOrder', params: { orderNo: row.messageKey } })
          })
        })
      } else if (row.messageClassify == 1) {
        this.$router.push({ name: 'messageLook', query: { id: row.id } })
      }
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      receiveMsgList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    tableStyle () {
      return 'height: 50px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
  .pags {
    width: 100%;
    text-align: center;
  }
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;
    .chuKuZuoyeWarp-body-queryIpt {
      width: 100%;
      display: flex;
      ul {

        flex: 1;
        flex-direction: column;
        display: flex;
        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }
    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }
    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }
  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
}
/deep/.el-table .cell{
  text-align: left;
}
/deep/.is-right .cell{
  text-align: right;
}
</style>
